import loadScript from "../common/loadScript";

export const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.src = entry.target.dataset.src;
            entry.target.removeAttribute('data-src');

            if (!entry.target.classList.contains('with-background')) {
                entry.target.style.background = 'none';
            }

            observer.unobserve(entry.target);
        }
    })
}, {threshold: 0});

export const mapObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            loadScript('https://api-maps.yandex.ru/2.1/?lang=ru_RU&onload=App.contacts.onMapLoad');
            observer.unobserve(entry.target);
        }
    })
}, {threshold: 0.6});

export function initRussianPostWidgetObserver(target, callback) {
    let $target = $(target);

    if ($target.hasClass('observe') || $target.hasClass('initialized')) {
        return false;
    }

    const observer = new IntersectionObserver(
        (entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    ecomStartWidget({
                        id: 21913,
                        callbackFunction: callback,
                        containerId: entry.target.id,
                        start_location: entry.target.getAttribute('data-start-location'),
                    });

                    observer.unobserve(entry.target);
                    $target.removeClass('observe');
                }
            });
        },
        {
            threshold: 0.5,
        },
    );

    observer.observe(target);
    $target.addClass('observe');
}

export default function initSlickSliderObserver(target, options = {}) {
    let $target = $(target);

    if (target === null || $target.hasClass('observe') || $target.hasClass('slick-initialized')) {
        return false;
    }

    const slickObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                $(entry.target).slick(options);
                observer.unobserve(entry.target);
                $target.removeClass('observe');
            }
        })
    }, {threshold: 0.2});

    slickObserver.observe(target);
    $target.addClass('observe');
}